import type { paths } from '@orlikfy/api-interfaces';

// POST /analytics/events
export const TRACK_EVENTS_PATH = '/analytics/events' as const satisfies keyof paths;
type TrackEventsOperation = paths[typeof TRACK_EVENTS_PATH]['post'];
export type TrackEventsBody = TrackEventsOperation['requestBody']['content']['application/json'];
